'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _ = require('..');
var _constants = require('../../constants');

var _PropertyToolsBarMobile = require('./PropertyToolsBarMobile.scss');var styles = _interopRequireWildcard(_PropertyToolsBarMobile);
var _makeSharingUrl = require('../../utils/makeSharingUrl');var _makeSharingUrl2 = _interopRequireDefault(_makeSharingUrl);
var _formatSEOData = require('../../utils/formatSEOData');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}

var popupTypes = {
  notes: 'notes',
  share: 'share',
  additional: 'additional' };var


PropertyToolsBarMobile = function (_Component) {_inherits(PropertyToolsBarMobile, _Component);function PropertyToolsBarMobile() {var _temp, _this, _ret;_classCallCheck(this, PropertyToolsBarMobile);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      popup: null }, _this.










    clickHome = function (event) {
      event.preventDefault();
      if (_this.props.hideLightbox) {
        _this.props.hideLightbox();
      }
      _this.setState({ popup: null });
      _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/'));
    }, _this.

    goToBack = function (event) {
      event.preventDefault();
      _this.setState({ popup: null });
      if (_this.props.hideLightbox) {
        _this.props.hideLightbox();
      } else {
        _reactRouter.browserHistory.goBack();
      }
    }, _this.

    clickOutside = function () {return _this.setState({ popup: null });}, _this.

    checkIsProjects = function () {var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;return (0, _get2.default)(props, 'routeData.location') === 'project_details' ||
      (0, _get2.default)(props, 'preloadData.entityType') === _constants.ENTITY_TYPES.PROJECT;}, _this.

    openNoteInput = function (evt) {return _this.setState({ noteInputIsActive: evt });}, _this.

    openNote = function (evt) {
      evt.nativeEvent.stopImmediatePropagation();
      evt.stopPropagation();
      return _this.setState(function (prevState) {return {
          popup: prevState.popup === popupTypes.notes ? null : popupTypes.notes };});

    }, _this.

    openMenu = function (evt) {
      evt.nativeEvent.stopImmediatePropagation();
      _this.setState(function (prevState) {return {
          popup: prevState.popup === popupTypes.additional ? null : popupTypes.additional };});

    }, _this.

    share = function (evt) {
      evt.nativeEvent.stopImmediatePropagation();
      _this.setState(function (prevState) {return {
          popup: prevState.popup === popupTypes.share ? null : popupTypes.share };});

    }, _this.

    handleClick = function (evt) {return evt.nativeEvent.stopImmediatePropagation();}, _this.

    renderSave = function () {var _this$props =



      _this.props,isFavorite = _this$props.isFavorite,toggleFavorite = _this$props.toggleFavorite;

      return (
        _react2.default.createElement('p', { className: styles.saveWrapper, onClick: toggleFavorite },
          _react2.default.createElement('i', { className: 'icon icon-' + (isFavorite ? 'heart-straight-active' : 'heart-straight') })));


    }, _this.

    renderPropertyNote = function () {return (
        _react2.default.createElement('div', { className: styles.propertyNoteWrapper, onClick: _this.handleClick },
          _react2.default.createElement(_.NotePropertyInput, {
            openNote: _this.openNote,
            translate: _this.props.translate,
            placeholder: '' + _this.props.translate('notesPlaceholder'),
            placeholderTextArea: '' + _this.props.translate('notesPlaceholder'),
            addNote: _this.props.addPropertyNote,
            value: _this.props.fetchPropertyNote,
            handleClick: _this.openNoteInput,
            inputIsActive: _this.state.noteInputIsActive,
            className: 'propertyNote',
            isMobile: true })));}, _this.




    renderReportProperty = function () {return (
        _react2.default.createElement('div', { className: styles.reportPropertyWrapper },
          _react2.default.createElement(_.ReportProperty, {
            key: 'reportProperty',
            translate: _this.props.rootTranslate('reportProperty'),
            isForeign: _this.props.isForeign })));}, _this.




    renderEditButton = function () {return (
        _react2.default.createElement('p', {
            className: styles.handleEdit,
            onClick: _this.props.handleEdit },

          _react2.default.createElement('i', { className: 'icon icon-edit-silver' }),
          _this.props.translate('edit')));}, _this.



    renderMenu = function () {var
      propertyData = _this.props.propertyData;
      var userId = (0, _get2.default)(_this.props, 'userData.id');
      var ownerId = (0, _get2.default)(_this.props, 'propertyData.user_id') || (0, _get2.default)(_this.props, 'propertyData.owner_id');

      return (
        _react2.default.createElement('div', { className: styles.menu, onClick: _this.handleClick },
          !_this.props.withoutPrint && _this.renderPrint(),
          userId === ownerId && _this.renderEditButton(),
          _this.renderReportProperty()));


    }, _this.

    renderNotes = function () {var _cx;return (
        _react2.default.createElement('p', {
            onClick: _this.openNote,
            className: (0, _classnames2.default)((_cx = {}, _cx[
            styles.hasNote] = _this.props.fetchPropertyNote, _cx[
            styles.active] = _this.state.popup === popupTypes.notes, _cx)) },


          _react2.default.createElement('i', { className: 'icon icon-notes' })));}, _this.



    renderPrint = function () {return (
        _react2.default.createElement('p', { onClick: _this.props.hidePrintPage },
          _this.props.printPageShown ?
          _react2.default.createElement('i', { className: (0, _classnames2.default)('icon icon-om-spinner om-pulse', styles.spinner) }) :
          _react2.default.createElement('i', { className: 'icon icon-print-property' }),

          _this.props.translate('print')));}, _this.



    renderShare = function () {var _cx2;
      var target = _this.checkIsProjects() ? 'project' : 'home';
      var sharingUrl = (0, _makeSharingUrl2.default)('/' + target + '_details/' + _this.props.id, _this.props.locale);
      var protocol = sharingUrl.includes('://') ? '' : 'https://';

      return _this.props.isNative ?
      _react2.default.createElement('a', {
          href: '' + protocol + sharingUrl + '/open_share',
          target: '_blank',
          className: styles.phoneNative },

        _react2.default.createElement('i', { className: 'icon icon-export' })) :


      _react2.default.createElement('p', {
          onClick: _this.share,
          className: (0, _classnames2.default)((_cx2 = {}, _cx2[
          styles.active] = _this.state.popup === popupTypes.share, _cx2)) },


        _react2.default.createElement('i', { className: 'icon icon-export' }));


    }, _this.

    renderBackToSearch = function () {return (
        _react2.default.createElement('p', { onClick: _this.goToBack, className: styles.iconBackProperty },
          _react2.default.createElement('i', { className: 'icon icon-back-property' })));}, _this.



    renderOnMapLogo = function () {return (
        _react2.default.createElement(_reactRouter.Link, { to: (0, _appendLocale2.default)(_this.props.locale, '') || '/', className: styles.logo, onClick: _this.clickHome },
          _react2.default.createElement('img', {
            width: '112px',
            src: _this.props.isWhite ? _constants.onMapLogoWhite : _constants.onMapLogoBlue,
            alt: '' })));}, _temp), _possibleConstructorReturn(_this, _ret);}PropertyToolsBarMobile.prototype.componentDidMount = function componentDidMount() {document.addEventListener('click', this.clickOutside);};PropertyToolsBarMobile.prototype.componentWillUnmount = function componentWillUnmount() {document.removeEventListener('click', this.clickOutside);};PropertyToolsBarMobile.prototype.




  render = function render() {var _cx3, _cx4;
    var target = this.checkIsProjects() ? 'project' : 'home';
    var sharingData = {
      sharingUrl: (0, _makeSharingUrl2.default)('/' + target + '_details/' + this.props.id, this.props.locale),
      sharingTitle: (0, _formatSEOData.formatPropertyTitle)(
      (0, _get2.default)(this.props, 'propertyData'),
      (0, _get2.default)(this.props, 'propertyData.property_type'),
      this.props.translate('propertyDetails'),
      this.props.locale) };



    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.headerWrapper, (_cx3 = {}, _cx3[styles.whiteHeaderWrapper] = this.props.isWhite, _cx3)) },
        _react2.default.createElement('div', { className: styles.headerBlock },
          this.renderBackToSearch()),

        _react2.default.createElement('div', { className: styles.onMapLogoWrapper },
          this.renderOnMapLogo()),

        _react2.default.createElement('div', { className: styles.headerBlock },
          !this.props.withoutFavorite && this.renderSave(),
          this.renderShare(),
          !this.props.withoutNote && this.renderNotes(),
          _react2.default.createElement('div', {
              className:
              (0, _classnames2.default)(styles.menuClosed, (_cx4 = {}, _cx4[styles.menuOpened] = this.state.popup === popupTypes.additional, _cx4)),

              onClick: this.openMenu },

            _react2.default.createElement('i', { className: 'icon icon-menu-closed' }))),


        this.state.popup === popupTypes.notes && this.renderPropertyNote(),
        this.state.popup === popupTypes.share &&
        _react2.default.createElement('div', { className: styles.shareMenu, onClick: this.handleClick },
          _react2.default.createElement(_.ShareBlock, {
            sharingData: sharingData,
            isMobile: this.props.isMobile,
            locale: this.props.locale,
            copyLinkTitle: '' + this.props.translate('copyLink'),
            shareTitle: '' + this.props.translate('companyPage', 'shareTitle'),
            className: 'companySocialIcons',
            isCloseЕitle: true,
            inColumn: true,
            withSocialName: true,
            translate: this.props.translate,
            emailTitle: sharingData.sharingTitle })),



        this.state.popup === popupTypes.additional && this.renderMenu(),
        this.state.popup &&
        _react2.default.createElement('div', { className: styles.background })));


  };return PropertyToolsBarMobile;}(_react.Component);exports.default = PropertyToolsBarMobile;


PropertyToolsBarMobile.propTypes = {
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  rootTranslate: _propTypes2.default.func,
  toggleFavorite: _propTypes2.default.func,
  hideLightbox: _propTypes2.default.func,
  addPropertyNote: _propTypes2.default.func,
  isFavorite: _propTypes2.default.bool,
  isForeign: _propTypes2.default.bool,
  hidePrintPage: _propTypes2.default.func,
  handleEdit: _propTypes2.default.func,
  printPageShown: _propTypes2.default.bool,
  withoutPrint: _propTypes2.default.bool,
  withoutNote: _propTypes2.default.bool,
  withoutFavorite: _propTypes2.default.bool,
  isWhite: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  fetchPropertyNote: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  isNative: _propTypes2.default.bool,
  routeData: _propTypes2.default.object,
  preloadData: _propTypes2.default.object,
  propertyData: _propTypes2.default.object,
  userData: _propTypes2.default.object };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyToolsBarMobile/PropertyToolsBarMobile.js
// module id = 2855
// module chunks = 0